// Dexie（IndexedDB）スキーマ定義（CONTRACTS.md §2）

import Dexie, { type Table } from 'dexie';
import type { Category, Expense, Budget } from './types';

export class AppDB extends Dexie {
  categories!: Table<Category, string>;
  expenses!: Table<Expense, string>;
  budgets!: Table<Budget, string>;

  constructor() {
    super('expense-tracker-db');
    this.version(1).stores({
      categories: 'id, name, sortOrder',
      expenses: 'id, categoryId, date, [categoryId+date]',
      budgets: 'id, categoryId, yearMonth, [categoryId+yearMonth]',
    });
  }
}

export const db = new AppDB();
